export enum WatchlistLabel {
    shortTerm = 'Short-Term',
    longTerm = 'Long-Term',
    halalStocks = 'Halal-Stocks',
    multiBagger = 'Multi-Bagger'
};

export const timeFrameConfig = {
    '1D': '5Min', 
    '1W': '1H',
    '1M': '1D',
    '3M': '1D',
    'YTD': '1D',
    '6M': '1D',
    '1Y': '1D',
    '1A': '1D',
    'all': '1D'
};